class TempMap extends Map {
  constructor() {
    super(...arguments);
    this.timeoutId = -1;
  }
  set(key, value) {
    if (this.timeoutId === -1) {
      this.timeoutId = setTimeout(() => {
        super.clear();
      }, 300);
    }
    return super.set(key, value);
  }
}
export {
  TempMap as T
};
//# sourceMappingURL=TempMap-035b2408.mjs.map
